export type FileType =
  | "pdf"
  | "csv"
  | "excel"
  | "image"
  | "powerpoint"
  | "word"
  | "database"
  | "unknown";

export function getFileTypeByName(filename: string): FileType {
  const name = filename.toLowerCase();

  if (name.endsWith(".pdf")) return "pdf";
  if (name.endsWith(".csv")) return "csv";
  if (/\.(xlsx?|xlsm|xlsb)$/.test(name)) return "excel";
  if (/\.(png|jpe?g|gif|webp|bmp|svg|ico)$/.test(name)) return "image";
  if (/\.(pptx?|pps|ppsx)$/.test(name)) return "powerpoint";
  if (/\.(docx?|rtf|odt)$/.test(name)) return "word";

  return "unknown";
}
